import { useContext, useState, useEffect } from 'react';

// imports relevant for HTTP calls
import DisplayException from '../../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import { SERVER_URL } from '../../config_server_url';

// ----- Imports for main window --------

import UserSessionContext from '../../user_session/context_user_session';

function CycleSetup(props) {

    const usr_session_ctx = useContext(UserSessionContext);
    
    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    
    // ------------------ Main window -----------------------------------------
    const [cycle, setCycle] = useState({});
    const [showModify, setShowModify] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true); // Set loading state to true when fetch begins
            const data = {
                uuid_opt_campaign: props.uuid_opt_campaign,
                cycle_id: props.cycle_id,
            };
            try {
                // Prepare the fetch requests
                const response = await fetch(`${SERVER_URL}/current_opt_campaign/load_optimization_cycle/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'uuid_tenant': usr_session_ctx.uuid_tenant
                    },
                    body: JSON.stringify(data),
                });
                // Check responses
                if (!response.ok) {
                    throw new Error(`HTTP error ${response.status}`);
                }
                // Parse JSON from responses
                const loaded_cycle = await response.json();
                // Update state with loaded data
                setCycle(loaded_cycle.data);
                if (loaded_cycle.data.all_candidates.length > 0 ||
                    loaded_cycle.data.uuid_ml_models.length > 0){
                    setShowModify(false)

                }
                // Set loading state to false
                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);
                setException(true);
                setExceptionMessage(`HTTPException: err_msg=${err.message}`);
            }
        };
        if(props.cycle_id >=0){
            loadData();
        }
    }, [props.cycle_id, props.uuid_opt_campaign, usr_session_ctx.uuid_tenant]);




    let setup = (<></>)
    if(Object.keys(cycle).length > 0){
    setup = (<>
        <div style={{display:'flex', alignItems:'center', width:'95%'}}>
            <h4 style = {{margin:'0px', marginTop:'10px', marginLeft:'10px', marginBottom:'5px', width:'fit-content'}} >
                Cycle Setup
            </h4>
        </div>
        <div style = {{display:'flex', fontSize:'14px', alignItems:'center', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%'}}>
            <div style={{width:'480px'}}>Experimental Workflow (uuid: {cycle.campaign_setup.uuid_experimental_setup}) </div>
            <button id={`view_experimentalWorkflow_${props.cycle_id}`} 
                    className='cellButton'
                    style={{marginLeft: '10px'}}
                    onClick={props.onView}> 
                view
            </button>
            {cycle.active && showModify && (
            <button id={`edit_experimentalWorkflow_${props.cycle_id}`} 
                    className='cellButton' 
                    style={{marginLeft: '-5px'}}
                    onClick={props.onEdit}>
                modify
            </button>
              )}
        </div>
        <div style = {{display:'flex', fontSize:'14px', alignItems:'center', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%'}}>
            <div style={{width:'480px'}}>Design Space (uuid: {cycle.campaign_setup.uuid_design_space})</div>
            <button id={`view_designSpace_${props.cycle_id}`} 
                    className='cellButton' 
                    style={{marginLeft: '10px'}} 
                    onClick={props.onView}> 
                view
            </button>
            {cycle.active && showModify && (
            <button id={`edit_designSpace_${props.cycle_id}`}
                    className='cellButton'
                    style={{marginLeft: '-5px'}}
                    onClick={props.onEdit}>
                modify
            </button>
              )}
        </div>
        <div style = {{display:'flex', fontSize:'14px', alignItems:'center', margin:'0px', marginLeft:'10px', marginBottom:'5px', height:'fit-content', width:'95%'}}>
            <div style={{width:'480px'}}>Objective (uuid: {cycle.campaign_setup.uuid_objective})</div>
            <button id={`view_objective_${props.cycle_id}`} 
                    className='cellButton' 
                    style={{marginLeft: '10px'}}
                    onClick={props.onView}> 
                view
            </button>
            {cycle.active && showModify && (
            <button id={`edit_objective_${props.cycle_id}`} 
                    className='cellButton'
                    style={{marginLeft: '-5px'}}
                    onClick={props.onEdit}>
                modify
            </button>
              )}
        </div>
    </>);
    }






    if(isLoading && !Exception){
        return (<div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'90%'}} >
                    <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
            </div>);
    }

    if(Exception){
        return (<>
                <div style={{display:'flex', justifyContent:'center', alignItems:'center',height:'90%'}} >
                    <DisplayException>
                        {ExceptionMessage}
                    </DisplayException>  
                </div>
            </>);
    }



    return (<>
        <div style = {{width: `${props.width * 0.91 - 20}px`, marginLeft: '20px', background: 'white', marginTop: '20px', marginBottom: '20px', border:'0.5px solid var(--aixelo-gray-light)'}}>
            {setup}
        </div>
    </>);

}


export default CycleSetup